(function () {
    "use strict";

    angular.module("app").component("habilInstallationZones", {
        templateUrl: "@/installation/installation-zones.template.html",
        bindings: { zones: "<" },
        controller: InstallationZonesController
    });


    InstallationZonesController.$inject = ["$rootScope", ];
    function InstallationZonesController($rootScope) {
        const $controller = this;

        $controller.$onChanges = initialize;
        $controller.AdministrativeZones = null;
        $controller.useCases = $rootScope.codeSecuredZoneUseCases;
        $controller.zoneHasUseCase = zoneHasUseCase;

        function initialize(changes) {
            if (!changes.zones || !Array.isArray(changes.zones.currentValue))
                return;

            let administrativeZones = $controller.zones.filter(z => z.Type == 0);

            for (const az of administrativeZones)
                az.Children = $controller.zones.filter(z => z.ParentId === az.PublicId);

            $controller.AdministrativeZones = administrativeZones;
        }

        function zoneHasUseCase(securedZone, useCase) {
            return securedZone.UseCases.includes(useCase);
        }
    }
})();
